import styled from 'styled-components';
import Box, { BoxProps } from '@material-ui/core/Box';
import { WithMyTheme } from '@keaze/web/theme';

interface ContainerProps extends WithMyTheme {
  $isPreview: boolean;
}

export const Carousel = styled(Box)`
  position: relative;
  overflow: hidden;

  &:hover {
    button {
      &:first-child {
        left: 0;
      }

      &:last-child {
        right: 0;
      }
    }
  }
`;

export const Container = styled(Box)<ContainerProps & BoxProps>`
  ${({ theme: { breakpoints }, $isPreview }) => `
    ${$isPreview && 'height: 210px'};
    display: flex;

    ${breakpoints.up('sm')} {
      height: 300px;
    }

    ${breakpoints.up('md')} {
      height: 405px;
    } 
  `}
`;

export const Slide = styled(Box)`
  ${({ theme: { breakpoints } }) => `
    position: relative;
    flex: 0 0 100%;
span {display: block !important}
    img {
      width: 100%;
      height: 100%;
      object-fit: cover !important;
    }

    ${breakpoints.up('sm')} {
      & > div {
        width: 100%;
        height: 100%;
      }
    }
  `}
`;

export const ViewPort: any = styled(Box)`
  overflow: hidden;
  width: 100%;
`;
